import templateUrl from './itemsListByExpectedUpc.html'

/**
 * A list of items grouped by upc and by expected/unexpected status.
 *
 * @example
 *   <tmr-items-list-by-expected-upc items="$ctrl.itemsByExpectedUpc"></tmr-items-list-by-expected-upc>
 *
 * @type {ngComponent}
 * @prop {array} items an array of groups generated by {@link TmrMovementHelper.groupitemsByExpectedUpc}
 * @prop {boolean=} [completed=false] If true, the operation is completed and missing items are considered an error
 */
export const tmrItemsListByExpectedUpc = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrItemsListByExpectedUpcController',
  bindings: {
    items: '<',
    completed: '<?',
  },
}

/**
 * Controller of component {@link tmrItemsListByExpectedUpc}.
 *
 * @type {ngController}
 */
export class tmrItemsListByExpectedUpcController {
  static ngType = 'controller'

  constructor($mdDialog) {
    'ngInject'
    Object.assign(this, { $mdDialog })
  }

  showItemsByUpcDialog(
    targetEvent,
    { upc, unexpected, epcs, expectedEpcs, statusByEpc }
  ) {
    this.$mdDialog.show(
      this.$mdDialog.tmrItemsByUpc({
        targetEvent,
        locals: {
          upc,
          unexpected,
          missing: this.completed && epcs.length < expectedEpcs.length,
          epcs,
          expectedEpcs,
          statusByEpc,
        },
      })
    )
  }
}
